import React from 'react';
import { Table } from 'semantic-ui-react';
import { TableHeaderCell } from 'utils/types';
import css from './UnsortableHeaderCell.scss';
import { omit } from 'lodash';

export default class UnsortableHeaderCell extends React.Component {

  render() {
    return <Table.HeaderCell className={css["header-cell"]}
                             role="columnheader"
                             scope="col"
                             {...omit(this.props.header, ['content', 'sortValue'])}>
      {this.props.header.content}
    </Table.HeaderCell>
  }

}

UnsortableHeaderCell.propTypes = {
  header: TableHeaderCell.isRequired
}
